import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import './index.css';
import App from './App';
import { StepTeacherPersonalInfoComponent } from './StepTeacherPersonalInfoComponent';
import { StepSuccessComponent } from './StepSuccessComponent';
import { StepDocUploadComponent } from './StepDocUploadComponent';
import { StepPendingComponent } from './StepPendingComponent';

setOptions({
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    messages: {
        "organization" : "School",
        "firstName" : "First Name",
        "lastName" : "Last Name",
        "emailAddress" : "Email Address",
        "postalCode" : "Home Zip Code",
        "step" : {
            "personalInfo" : {
                "subtitle" : "Confirm your eligibility by simply completing the form below.",
            },
            "docUpload" : {
                "fileInstructions" : "Choose file",
                "submitButtonLabel" : "SUBMIT FOR REVIEW",
            }
        }
    }
});

// @ts-ignore
overrideComponent('StepTeacherPersonalInfoComponent', StepTeacherPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
overrideComponent('StepPendingComponent', StepPendingComponent);

ReactDOM.render(<App />, document.getElementById('root'));
